import { SchoolReportingFilters } from "../school-reporting-filters.model";

export interface DrillDownDetails {
    drillDownType: DrillDownType;
    drillDownTitle ?: string;

    filters: SchoolReportingFilters

    studentCourseIds?: number[];
    referenceInfo?: ReferenceInfo;
}

export enum DrillDownType {
    studentsEnrolledInCourse = 'studentsEnrolledInCourse',
    studentsEnrolled = 'studentsEnrolled',
    assignmentsCurrent = 'currentAssignments',
    assignmentsPastDue = 'pastDueAssignments',
    acsTestTaken = 'acsTestsTaken',
    acsTestAwaitingUpload = 'acsTestsAwaitingUpload',
    none = "none",
}

export interface ReferenceInfo {
    referenceKey: number;
    referenceDescription: string;
}